// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"169":"619571aa0a594488","4863":"c4f4fca357ed60dd","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","6572":"996c7aa002eedcb7","8232":"db776de4ae592dad"}[chunkId] + ".css";
};